import { Instance } from 'mobx-state-tree';
import { UserInviteRevokedDtoModelBase } from './UserInviteRevokedDtoModel.base';

/* The TypeScript type of an instance of UserInviteRevokedDtoModel */
export interface UserInviteRevokedDtoModelType extends Instance<typeof UserInviteRevokedDtoModel.Type> {}

/* A graphql query fragment builders for UserInviteRevokedDtoModel */
export { selectFromUserInviteRevokedDto, userInviteRevokedDtoModelPrimitives, UserInviteRevokedDtoModelSelector } from './UserInviteRevokedDtoModel.base';

/**
 * UserInviteRevokedDtoModel
 */
export const UserInviteRevokedDtoModel = UserInviteRevokedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
